import { CityGroup } from '@/entities/campaign';

export const NCR_CITIES = [
  'Delhi',
  'Gurugram',
  'Noida',
  'Ghaziabad',
  'Greater Noida',
  'Gurgaon',
];
export const NCR_STATES = ['Delhi', 'Haryana'];

export const DELHI_NCR: CityGroup = {
  id: 'delhi-ncr',
  name: 'Delhi-NCR',
  displayName: 'Delhi-NCR',
  image: 'https://images.justbaat.com/city-group/delhi.png',
  disabled: true,
  states: NCR_STATES,
  cities: NCR_CITIES,
};
